import { render, staticRenderFns } from "./videoList.vue?vue&type=template&id=de421ef2&scoped=true&"
import script from "./videoList.vue?vue&type=script&lang=tsx&"
export * from "./videoList.vue?vue&type=script&lang=tsx&"
import style0 from "./videoList.vue?vue&type=style&index=0&id=de421ef2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de421ef2",
  null
  
)

export default component.exports